import { format } from "date-fns";
import Button from "shared/components/Button";

interface DateOptionProps {
  date: Date;
  isSelected: boolean;
  spherePhotoAvailable: boolean;
  scoutPhotoAvailable: boolean;
  onClick: (selectedDate: DateOptionProps["date"]) => void;
}

export const DateOption: React.FC<DateOptionProps> = ({
  date,
  isSelected,
  spherePhotoAvailable,
  scoutPhotoAvailable,
  onClick,
}) => {
  return (
    <Button
      colour="Theme"
      disabled={!spherePhotoAvailable && !scoutPhotoAvailable}
      additionalClassNames={`NoPadding NoOverflow ${
        isSelected ? "Active" : ""
      } DateOption`}
      onClick={() => onClick(date)}
    >
      <div className="DateOptionTitle">{format(date, "eee")}</div>
      <div className="DateOptionBody DisplayFlex FlexColumn VSmallGap">
        <div>{format(date, "d")}</div>
        <div className="DisplayFlex VSmallGap">
          <div className={dateIconClass("SpherePhoto", spherePhotoAvailable)} />
          <div className={dateIconClass("ScoutPhoto", scoutPhotoAvailable)} />
        </div>
      </div>
    </Button>
  );
};

export const dateIconClass = (
  iconClass: "SpherePhoto" | "ScoutPhoto",
  isAvailable: boolean
): string =>
  `AvailabilityIcon ${iconClass} ${isAvailable ? "" : "Unavailable"}`;
